<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      titulo="Registro de auditoría"
      icono="mdi-clipboard-search-outline"
      tabla-vista="regaud"
      orden-inicial="fechor DESC"
      busqueda-rapida
      :filas-por-pagina="20"
      dense
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
};
</script>

<style>
</style>